import React from "react";
import { useNavigate } from 'react-router-dom';

import './Sidebar.css';

type SidebarProps = {
  user: { name: string },
  current: string,
  nav?: (page: string) => void
};

const Sidebar: React.FC<SidebarProps> = ({ user, current, nav }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    navigate('/login');
  };
  return (
  <aside className="sidebar">
    <div className="sidebar-logo">
      <img
        src="/logo_only_256x256.png"
        alt="Pipelyze"
        className="sidebar-logo-img"
        width={128}
        height={40}
        draggable={false}
      />
      <span className="sidebar-logo-text">Pipelyze</span>
    </div>
    <nav className="sidebar-nav">
      <a className={current === "dashboard" ? "active" : ""} href="/dashboard">Dashboard</a>
      <a className={current === "repos" ? "active" : ""} href="/dashboard/repos">Repositories</a>
      <a className={current === "settings" ? "active" : ""} href="/dashboard/settings">Settings</a>
    </nav>
    <div className="sidebar-bottom">
      <div className="sidebar-user">
        <span className="sidebar-avatar">{user.name[0]}</span>
        <div>
          <span className="sidebar-username">{user.name}</span>
          <button className="logout-btn" onClick={handleLogout}>Logout</button>
        </div>
      </div>
    </div>
  </aside>
  );
};
export default Sidebar;